export interface ConfigNameAndDescription {
  name: string;
  description?: string;
  uploadedby?: string;
  uploadtimeutc?: string;
}

export interface AppVersionViewModel {
  dtoVersion: string;
  uiVersion: string;
  description?: string;
  uploadedBy?: string;
  isActive?: boolean;
  dateStr: string;
  activationTimeUtc?: Date;
}

export interface ActiveConfigInfo {
  fileName: string;
  activationTimeUtc?: string;
}

export enum SiteAppModule {
  Mcs = "Mcs",
  Das = "Das",
  Opi = "Opi",
  TagsHarvester = "TagsHarvester",
  CamerasControl = "CamerasControl",
  Redis = "Redis",
}

export type SiteControlModule = SiteAppModule.Mcs | SiteAppModule.Das | SiteAppModule.Opi;

export enum ModuleRuntimeStatus {
  NotExist = "NotExist",
  Running = "Running",
  Stopped = "Stopped",
  Failed = "Failed",
  Backoff = "Backoff",
  Unhealthy = "Unhealthy",
}

export const siteControlModuleDisplayName: Record<SiteControlModule, string> = {
  [SiteAppModule.Mcs]: "MCS",
  [SiteAppModule.Das]: "DAS",
  [SiteAppModule.Opi]: "OPI",
};

export const siteAppModuleToIotHubModuleName: Record<SiteAppModule, string> = {
  [SiteAppModule.Mcs]: SiteAppModule.Mcs,
  [SiteAppModule.Das]: SiteAppModule.Das,
  [SiteAppModule.Opi]: "on-prem-interface",
  [SiteAppModule.TagsHarvester]: SiteAppModule.TagsHarvester,
  [SiteAppModule.CamerasControl]: SiteAppModule.CamerasControl,
  [SiteAppModule.Redis]: SiteAppModule.Redis,
};

export const siteControlModuleToVersionTagName: Record<SiteControlModule, string> = {
  [SiteAppModule.Mcs]: "mcs_version",
  [SiteAppModule.Das]: "das_version",
  [SiteAppModule.Opi]: "on-prem-interface_version",
};
